<template>
  <div class="mb-8">
    <h1 class="text-[24px] sm:text-3xl font-bold text-gray-900 mb-2">
      Teacher Management
    </h1>

    <p class="text-[11px] sm:text-base text-gray-600">
      Manage teachers in your school system
    </p>
  </div>
</template>

<script>
  export default {};
</script>

<style></style>
